"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A horizontal divider whose width and spacing can be adjusted
 */
var Separator = _styledComponents.default.div.withConfig({
  displayName: "Separator",
  componentId: "sc-49gck8-0"
})(["border:1px solid ", ";border-bottom-width:0;", ";", ";"], (0, _helpers.color)("black10"), _styledSystem.space, _styledSystem.width);

exports.Separator = Separator;
Separator.defaultProps = {
  width: "100%"
};
//# sourceMappingURL=Separator.js.map